import { Tokens } from '@/assets/tokens'
import styled, { css } from 'styled-components'

interface EmojiStyledProps {
  $active: boolean
}

const BaseEmoji = styled.path<EmojiStyledProps>`
  fill: #dee2ef;
`

export const PositiveEmoji = styled(BaseEmoji)`
  ${({ $active: active }) =>
    active &&
    css`
      fill: #537E35;
    `}
`

export const FavorableEmoji = styled(BaseEmoji)`
  ${({ $active: active }) =>
    active &&
    css`
      fill: #A9D18E;
    `}
`

export const UnfavorableEmoji = styled(BaseEmoji)`
  ${({ $active: active }) =>
    active &&
    css`
      fill: #F8CBAD;
    `}
`

export const NegativeEmoji = styled(BaseEmoji)`
  ${({ $active: active }) =>
    active &&
    css`
      fill: #BE0000;
    `}
`

export const NeutralEmoji = styled(BaseEmoji)`
  ${({ $active: active }) =>
    active &&
    css`
      fill: ${Tokens.ColorTextTertiary};
    `}
`
